import React, { useContext } from 'react';
import { defineMessages, t } from '@sm/intl';
import subdomainUri from '../../../../../helpers/subDomainUri';
import { StaticContext } from '../../../../..';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  DEVELOP: {
    id: 'Develop.develop',
    defaultMessage: 'Develop',
    description: '[Type: Label][Vis.: low] - Develop link in main navigation',
  },
});

const Develop = () => {
  const {
    environment: { domain, subdomain, tld } = {
      domain: 'surveymonkey',
      subdomain: 'www',
      tld: 'com',
    },
  } = useContext(StaticContext);

  const appsPath = subdomainUri({
    altdomain: 'developer',
    domain,
    subdomain,
    tld,
  });

  return <MainNavButton href={appsPath} label={t(COPY.DEVELOP)} />;
};

export default Develop;
export { Develop };
